var paletteValues = {
    divider: '#DBDCDF',
    common: {
        black: '#000',
        white: '#fff',
    },
    primary: {
        light: '#95BECF',
        main: '#2D7EA0',
        dark: '#064F6D',
        // Added to match and counterpart with Tebra definition
        50: '#EAF2F6',
        contrastText: '#fff',
    },
    secondary: {
        light: '#ED9A90',
        main: '#DD3722',
        dark: '#A32A19',
        contrastText: '#fff',
    },
    // Only added to match and counterpart with Tebra definition
    vitality: {
        light: '#95BECF',
        main: '#2D7EA0',
        dark: '#064F6D',
        contrastText: '#fff',
    },
    // Only added to match and counterpart with Tebra definition
    core: {
        200: '#DBDCDF',
    },
    error: {
        light: '#FCEBE9',
        main: '#DD3722',
        dark: '#A32A19',
        contrastText: '#fff',
    },
    warning: {
        light: '#FDF3E3',
        main: '#BD5800',
        dark: '#AC5000',
        contrastText: '#fff',
    },
    info: {
        light: '#95BECF',
        main: '#2D7EA0',
        dark: '#064F6D',
        contrastText: '#fff',
    },
    success: {
        light: '#EAF3E6',
        main: '#2C8700',
        dark: '#226600',
        contrastText: '#fff',
    },
    grey: {
        '300': '#EDEEF1',
        '400': '#DBDCDF',
        '500': '#B3B4BB',
        '600': '#72767F',
        '900': '#232A2F',
        contrastText: '#fff',
    },
    text: {
        primary: '#232A2F',
        secondary: '#72767F',
        disabled: '#B3B4BB',
        hint: '#72767F',
    },
    background: {
        paper: '#fff',
        default: '#EDEEF1',
    },
    action: {
        active: '#064F6D',
        hover: '#EAF2F6',
        selected: '#EAF2F6',
        disabled: 'rgba(0, 0, 0, 0.5)',
        focus: '#064F6D',
    },
};
export default paletteValues;
